import { render, staticRenderFns } from "./Stimuli.vue?vue&type=template&id=8da973e8&scoped=true"
import script from "./Stimuli.vue?vue&type=script&lang=js"
export * from "./Stimuli.vue?vue&type=script&lang=js"
import style0 from "./Stimuli.vue?vue&type=style&index=0&id=8da973e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da973e8",
  null
  
)

export default component.exports